module.exports = __webpack_public_path__ + "img/cardImg4.105703b7.png";